'use client';

import RouteError from '@/shared/components/error/RouteError';

/**
 * External Layout Error Boundary
 *
 * Catches errors that occur anywhere within the (external) route group
 * (marketing pages, pricing, public-facing content).
 */
export default function ExternalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return <RouteError error={error} reset={reset} />;
}
